import { createFileRoute } from '@tanstack/react-router';

// Rendered by the parent `groups` route, which stays mounted while the selected group changes.
export const Route = createFileRoute('/_authenticated/_shell/admin/groups/$groupId')({});
